import React from "react";
import { useMsal, useAccount, useIsAuthenticated } from "@azure/msal-react";

const SignIn = () => {
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const account = useAccount(accounts[0] || {});

  const handleLogin = () => {
    console.log(inProgress);
    if (inProgress === "none") {
      instance.loginRedirect();
    }
  };

  const handleLogout = () => {
    instance.logoutRedirect();
  };
 
  if (inProgress !== "none") {
  const statusText =
        inProgress === "login"
          ? "Signing In..."
          : inProgress === "logout"
          ? "Signing Out..."
          : "Completing Sign In...";    
    return (
      <div style={styles.container}>
        {
          <div style={styles.authenticated}>
            <button onClick={handleLogout} style={styles.buttonDisabled} disabled={true}>{statusText}</button>            
          </div>
        }
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {isAuthenticated && account ? (
        <div style={styles.authenticated}>
          <span style={styles.text}>{account.username}</span>
          <button onClick={handleLogout} style={styles.button}>
            Sign Out
          </button>
        </div>
      ) : (
        <button onClick={handleLogin} style={styles.button}>
          Sign In
        </button>
      )}
    </div>
  );
};

const styles = {
  container: {
    position: "absolute",
    top: "1rem",
    right: "1.75rem",
    zIndex: 1000,
  },
  authenticated: {
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
  },
  text: {
    // fontWeight: "bold",
  },
  button: {
    padding: "0.5rem 1rem",
    fontSize: "1rem",
    cursor: "pointer",
    margin: "0rem 0rem 0rem 0.5rem",
    backgroundColor: "#0078D4",
    color: "#fff",
    border: "none",
    borderRadius: "4px",    
  },
  buttonDisabled: {
    padding: "0.5rem 1rem",
    fontSize: "1rem",
    cursor: "pointer",
    margin: "0rem 0rem 0rem 0.5rem",
    backgroundColor: "#003645",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "default",
    opacity: 0.4,
  },
};

export default SignIn;
